import React,{useState} from 'react';
import TwoPhoneSection from "./TwoPhoneSection";
import {NavLink} from "react-router-dom";
import ThreePhoneCommonMainAction from "./ThreePhoneCommonMainAction";
import TeeRating from "./TeeRating";
import Usp from "./Usp";
import FormWithBackGroundImage from "../common/FormWithBackGroundImage";
import ThankYou from '../Form/ThankYou';
import ContactForm from '../../components/Contact/ContactForm';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ForClub = () => {
  const [thanku, setthanku] = useState(false)
  return (
    <div className="for__club">
      <FormWithBackGroundImage
      heading={'THINK YOUR CLUB COULD BENEFIT?'}
      subHeading={"CONTACT US BELOW FOR MORE INFO"}
      btnText={'SIGNUP NOW'}
      dataLayout={
        <>
            {
                thanku ?
                <ThankYou
                        setthanku={setthanku}
                        centerClass={"club__form__wrapper__form__center"} 
                        
                    /> :
                    <ContactForm
                        setthanku={setthanku}
                        toast={toast}
                        centerClass={"club__form__wrapper__form__center"} 
                    />
            }
            </>
      }

      />
     <TwoPhoneSection
                heading={"RESOLVE SLOW PLAY WITH TIMELY GOLF"}
                show_btn={true}
                className={""}
                btnLayout={
                    <div className="home__section2__right__btn">
                        <NavLink to="/club-detail" target="_self" className="res-btn-primary">SIGN UP</NavLink>
                        <NavLink to="/contact" target="_self" className={"res-btn-secondary"}>CONTACT US</NavLink>
                    </div>
                }
            />
            <TwoPhoneSection
                heading={"DIGITAL SCORE LOGGING AND GAME HISTORY"}
                show_btn={true}
                className={"reverse"}
                btnLayout={<div className="home__section2__right__btn">
                    <NavLink to="/club-detail" target="_self" className="res-btn-primary">SIGN UP</NavLink>
                    <NavLink to="/contact" target="_self" className={"res-btn-ternary"}>CONTACT US</NavLink>
                </div>}
            />
            <ThreePhoneCommonMainAction
                heading={<span>REVOLUTIONARY <br/> GOLFING APP</span>}
                imgSrc={require("../../assets/images/pages/home/section_1/home_hero_section.svg").default}
                show_subHeading={true}
            />
            <TeeRating />
            <Usp />
    </div>
  );
};

export default ForClub;
